// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-timeline[data-v-538cb940] {\n  list-style: none;\n  position: relative;\n}[dir] .app-timeline[data-v-538cb940] {\n  padding: 0;\n  margin: 0;\n}[dir=ltr] .app-timeline[data-v-538cb940] {\n  margin-left: 1rem;\n}[dir=rtl] .app-timeline[data-v-538cb940] {\n  margin-right: 1rem;\n}", ""]);
// Exports
module.exports = exports;
